// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file common/aimark.proto (package lvdr.v2.common, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file common/aimark.proto.
 */
export const file_common_aimark: GenFile = /*@__PURE__*/
  fileDesc("ChNjb21tb24vYWltYXJrLnByb3RvEg5sdmRyLnYyLmNvbW1vbiKLAQoGQWlNYXJrEhsKE2RpZ2l0YWxfc291cmNlX3R5cGUYASABKAkSEAoIcHJvdmlkZXIYAiABKAkSDgoGc3lzdGVtGAMgASgJEhAKCG1vZGVsX2lkGAQgASgJEjAKDGdlbmVyYXRlZF9hdBgFIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBCJ1olZ2l0aHViLmNvbS9ndnM0Mi9sdmRyL3Byb3RvL3YyL2NvbW1vbmIGcHJvdG8z", [file_google_protobuf_timestamp]);

/**
 * AiMark marks content as AI-generated (EU AI Act Art. 50(2)). Present means
 * generated; absent means not marked. Built only by internal/aimark.
 *
 * @generated from message lvdr.v2.common.AiMark
 */
export type AiMark = Message<"lvdr.v2.common.AiMark"> & {
  /**
   * IPTC digitalSourceType URI (trainedAlgorithmicMedia or compositeWithTrainedAlgorithmicMedia).
   *
   * @generated from field: string digital_source_type = 1;
   */
  digitalSourceType: string;

  /**
   * The Art. 50 provider, "LumaVista".
   *
   * @generated from field: string provider = 2;
   */
  provider: string;

  /**
   * "lumavista/<surface>".
   *
   * @generated from field: string system = 3;
   */
  system: string;

  /**
   * The served model; empty means not known.
   *
   * @generated from field: string model_id = 4;
   */
  modelId: string;

  /**
   * Unset means not known.
   *
   * @generated from field: google.protobuf.Timestamp generated_at = 5;
   */
  generatedAt?: Timestamp | undefined;
};

/**
 * Describes the message lvdr.v2.common.AiMark.
 * Use `create(AiMarkSchema)` to create a new message.
 */
export const AiMarkSchema: GenMessage<AiMark> = /*@__PURE__*/
  messageDesc(file_common_aimark, 0);

